src/components/Signin.vue
<template>
  <div class="signin">
    <h2>サインイン</h2>
    <input type="email" placeholder="メールアドレス" v-model="usermail" />
    <input type="password" placeholder="パスワード" @keydown.enter="signIn" v-model="password" />
    <button @click="signIn">サインイン</button>
    <p>
      アカウントをお持ちでない場合
      <router-link to="/signup">アカウントを作成する</router-link>
    </p>
  </div>
</template>

<script>
import firebase from "firebase/app";

export default {
  name: "Signin",
  data() {
    return {
      usermail: "",
      password: ""
    };
  },
  methods: {
    signIn: function() {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.usermail, this.password)
        .then(
          user => {
            console.log("signin");
            if (!firebase.auth().currentUser.emailVerified) {
              alert(
                "ユーザー認証が済んでおりません。メールから認証を完了してください。"
              );
              firebase.auth().currentUser.sendEmailVerification();
            } else {
              if (this.$route.params.goodvote) {
                console.log("go to " + this.$route.params.id);
                this.$router.replace({
                  name: "body",
                  params: {
                    id: this.$route.params.id,
                    content: this.$route.params.content
                  }
                });
              } else if (this.$route.params.form) {
                this.$router.replace({
                  name: "Post"
                });
              } else if (this.$route.params.recent) {
                this.$router.replace("/Recent");
              } else {
                this.$router.replace("/");
              }
            }
            user;
          },
          err => {
            alert(err.message);
          }
        );
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
a {
  color: #42b983;
}
.signin {
  margin-top: 20px;

  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
}
input {
  margin: 10px;
  padding: 10px;
}
</style>